import constants from '../../helpers/constants'

export default function (url) {
  return constants.TRANSLATIONS_PARAMS.LANGUAGE_PREFIX + url
}
